import request from '@/utils/request'

export function getWeightList(data) {
  return request({
    url: 'api/v1/tetris-weight/list',
    method: 'post',
    data: data
  })
}

export function updateWeight(data) {
  return request({
    url: 'api/v1/tetris-weight/update',
    method: 'post',
    data: data
  })
}

export function delWeight(data) {
  return request({
    url: 'api/v1/tetris-weight/delete',
    method: 'delete',
    data: data
  })
}

export function exportWeight(data) {
  return request({
    url: 'api/v1/tetris-weight/export',
    method: 'post',
    data: data
  })
}

export function importWeight(data) {
  return request({
    url: 'api/v1/tetris-weight/import',
    method: 'post',
    data: data
  })
}
